import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import app from "./AppReducer";
import vendor from "./VendorReducer";
import tracking from "./TrackingReducer";
import shop from "./ShopReducer";
import user from "./UserReducer";
import support from "./SupportReducer";

const reducers = (history) =>
  combineReducers({
    app,
    vendor,
    tracking,
    shop,
    user,
    support,
    router: connectRouter(history),
  });

export default reducers;
